export default function isCustomerLoaded(context, customerId) {
  return context.stores.customers.has({ id: customerId });
}
